import { render, staticRenderFns } from "./createPedidoProduto.vue?vue&type=template&id=a821ac9a&scoped=true&"
import script from "./createPedidoProduto.vue?vue&type=script&lang=js&"
export * from "./createPedidoProduto.vue?vue&type=script&lang=js&"
import style0 from "./createPedidoProduto.vue?vue&type=style&index=0&id=a821ac9a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a821ac9a",
  null
  
)

export default component.exports